import React from 'react'
import BadgeAchievement from './BadgeAchievement'

const JoinHistory = (props) => {

    const [usedCoin, setUsedCoin] = React.useState(0);
    const [winCount, setWinCount] = React.useState(0);

    // アクティベートクレジットの過去の使用数・優勝回数を取得
    React.useEffect(() => {
        let usedCoin = 0;
        if (props.userData.history && props.userData.history.activate) {
            Object.keys(props.userData.history.activate).forEach((key) => {
                usedCoin += props.userData.history.activate[key].usedCoin;
            });
        }
        setUsedCoin(usedCoin);

        let winCount = 0;
        if (props.userData.history && props.userData.history.join) {
            Object.keys(props.userData.history.join).forEach((key) => {
                if (props.userData.history.join[key].rank === 1) {
                    winCount++;
                }
            });
        }
        setWinCount(winCount);
    }, [props.userData]);

  return (
    <div className='p-3 mx-auto max-w-3xl pt-6 mb-3'>
        <h1 className='text-3xl text-center mb-8'><i className="bi bi-trophy me-2"></i>実績</h1>

        {/* ゲームの実績 */}
        <div className='bg-white shadow p-4 rounded-lg mx-4 mb-6'>
              <h2 className='text-2xl mb-3'>実績</h2>

              {/* バッジ */}
              <div className='grid md:grid-cols-4 grid-cols-2 text-center mb-4'>
                <BadgeAchievement name="ビギナー" description="初めて参加" icon="person-walking" active={props.userData.history && props.userData.history.join ? Object.keys(props.userData.history.join).length > 0 : false} />
                <BadgeAchievement name="アマチュア" description="3回以上参加" icon="person-arms-up" active={props.userData.history && props.userData.history.join ? Object.keys(props.userData.history.join).length >= 3 : false} />
                <BadgeAchievement name="プロ" description="2回以上優勝" icon="trophy" active={winCount >= 2} />
                <BadgeAchievement name="クリエイター" description="5つ以上作成" icon="palette" active={props.userData.history && props.userData.history.create ? Object.keys(props.userData.history.create).length >= 5 : false} />
                <BadgeAchievement name="ゲームマスター" description="200ptのクレジットを使用" icon="controller" active={usedCoin >= 200} />
              </div>

              <hr className='my-6' />

              {/* 回数表示 */}
              <div className='grid md:grid-cols-4 grid-cols-2 text-center'>
                <div className='mb-3'>
                    <label className='block text-sm font-medium text-gray-600'>参加回数</label>
                    <p className='text-xl ms-2'>{props.userData.history ? (props.userData.history.join ? Object.keys(props.userData.history.join).length : 0) : 0} 回</p>
                </div>
                <div className='mb-3'>
                    <label className='block text-sm font-medium text-gray-600'>優勝回数</label>
                    <p className='text-xl ms-2'>{winCount} 回</p>
                </div>
                <div className='mb-3'>
                    <label className='block text-sm font-medium text-gray-600'>ゲーム作成数</label>
                    <p className='text-xl ms-2'>{props.userData.history ? (props.userData.history.create ? Object.keys(props.userData.history.create).length : 0) : 0} 個</p>
                </div>
                <div className='mb-3'>
                    <label className='block text-sm font-medium text-gray-600'>実行回数</label>
                    <p className='text-xl ms-2'>{props.userData.history ? (props.userData.history.activate ? Object.keys(props.userData.history.activate).length : 0) : 0} 回</p>
                </div>
                <div className='mb-3'>
                    <label className='block text-sm font-medium text-gray-600'>消費クレジット</label>
                    <p className='text-xl ms-2'>{usedCoin} pt</p>
                </div>
              </div>
          </div>

          {/* 参加履歴 */}
          <div className='bg-white shadow p-4 rounded-lg mb-6 mx-4'>
              <h2 className='text-2xl mb-3'>参加履歴</h2>

              {
                props.userData.history && props.userData.history.join ? (
                  Object.keys(props.userData.history.join).sort((a, b) => props.userData.history.join[a].date - props.userData.history.join[b].date).map((key, index) => (
                    <div key={index} className='block text-left rounded-lg bg-white p-2 px-3 mb-3 border border-gray-100 hover:bg-gray-50 cursor-pointer relative' >
                        <div className='text-base mb-0.5'>{props.userData.history.join[key].name}</div>
                        {
                          props.userData.history.join[key].rank ? (
                            <div className='text-base text-green-700 tracking-wide'>{props.userData.history.join[key].rank}位 / <span className='text-sm'>{props.userData.history.join[key].totalTeams}チーム</span></div>
                          ) : (
                            <div className='text-sm text-gray-500'>結果なし</div>
                          )
                        }
                        <div className='text-sm text-gray-500 absolute end-2 bottom-2'>{new Date(props.userData.history.join[key].date).toLocaleString()}</div>
                    </div>
                  ))
                ) : (
                  <div className='text-center'>
                    <p className='text-base text-gray-600'>参加履歴はありません</p>
                  </div>
                )
              }
          </div>
    </div>
  )
}

export default JoinHistory